// 별별책방 - 본사 - 지사별 사용량 메인 페이지
import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle } from "react";

import axios from "@app/lib/axios";

import CommonHorizontalBarChart from "@app/components/CommonHorizontalBarChart";

import statStyle from "../components/style";

import CardStatContent from "../components/CardStatContent";

const statSummaryBase = { total: 0, v_total: 0, r_total: 0, s_total: 0 };
const BranchContent = forwardRef(({ branchList, statPeriod, selectedCategorySubOption = "k", updateCategorySubOption, selectedCategorySubOption2 = "play_count", updateCategorySubOption2 }, ref) => {
    const [subOptionApplied, setSubOptionApplied] = useState(false);
    const [statBranchList, setStatBranchList] = useState(false);
    const [stat, setStat] = useState(false);
    const [statAll, setStatAll] = useState(false);
    const [statSummary, setStatSummary] = useState({ ...statSummaryBase });
    useImperativeHandle(ref, () => ({
        getExcelData(callback) {
            const data = [];
            if (statBranchList) {
                statBranchList.forEach((b) => {
                    if (statAll && statAll.length > 0) {
                        const s = statAll.find((s) => b.id == s.branchId);
                        if (s) {
                            data.push([
                                b.name,
                                s.k_v_play_count,
                                s.k_v_play_count_sum,
                                s.k_r_play_count,
                                s.k_r_play_count_sum,
                                s.k_s_play_count,
                                s.k_s_play_count_sum,
                                s.m_v_play_count,
                                s.m_v_play_count_sum,
                                s.m_r_play_count,
                                s.m_r_play_count_sum,
                                s.m_s_play_count,
                                s.m_s_play_count_sum,
                                s.total_play_count,
                                s.total_play_count_sum,
                            ]);
                        }
                    }
                });
            }
            data.sort((a, b) => b[14] - a[14]);
            const excelData = {
                fileName: `모모한글수-지사별-통계`,
                sheets: [
                    {
                        name: "콘텐츠",
                        title: `모모한글수-지사별통계`,
                        columnTitle: {
                            rows: [
                                { title: ["지사", "한글", "한글", "한글", "한글", "한글", "한글", "수학", "수학", "수학", "수학", "수학", "수학", "합계(순)", "합계(누적)"], originColumn: 0 },
                                { title: ["영상", "영상", "리뷰", "리뷰", "스페셜", "스페셜", "영상", "영상", "리뷰", "리뷰", "스페셜", "스페셜"], originColumn: 1 },
                                { title: ["순", "누적", "순", "누적", "순", "누적", "순", "누적", "순", "누적", "순", "누적"], originColumn: 1 },
                            ],
                            merges: [
                                { s: { r: 0, c: 0 }, e: { r: 2, c: 0 } }, // branchName
                                { s: { r: 0, c: 1 }, e: { r: 0, c: 6 } }, // 한글
                                { s: { r: 0, c: 7 }, e: { r: 0, c: 12 } }, // 수학
                                { s: { r: 1, c: 1 }, e: { r: 1, c: 2 } }, // 한글-영상
                                { s: { r: 1, c: 3 }, e: { r: 1, c: 4 } }, // 한글-리뷰
                                { s: { r: 1, c: 5 }, e: { r: 1, c: 6 } }, // 한글-스페셜
                                { s: { r: 1, c: 7 }, e: { r: 1, c: 8 } }, // 수학-영상
                                { s: { r: 1, c: 9 }, e: { r: 1, c: 10 } }, // 수학-리뷰
                                { s: { r: 1, c: 11 }, e: { r: 1, c: 12 } }, // 수학-스페셜
                                { s: { r: 0, c: 13 }, e: { r: 2, c: 13 } }, // 합계(순)
                                { s: { r: 0, c: 14 }, e: { r: 2, c: 14 } }, // 합계(누적)
                            ],
                        },
                        data: data,
                    },
                ],
            };
            callback(null, excelData);
        },
    }));

    const clearStat = () => {
        setStatAll(false);
        setStat(false);
        setStatSummary(false);
    };

    const applyStatView = () => {
        const newStat = [];
        const newStatSummary = { ...statSummaryBase };

        const type = selectedCategorySubOption;
        const countType = selectedCategorySubOption2;

        if (statBranchList) {
            statBranchList.forEach((b) => {
                if (statAll && statAll.length > 0) {
                    const s = statAll.find((s) => b.id == s.branchId);
                    if (s) {
                        const bStat = { branchId: b.id, branchName: b.name, total: 0, v_play_count: 0, r_play_count: 0, s_play_count: 0 };
                        bStat.total = s[`${type}_v_${countType}`] + s[`${type}_r_${countType}`] + s[`${type}_s_${countType}`];
                        bStat.v_play_count = s[`${type}_v_${countType}`];
                        bStat.r_play_count = s[`${type}_r_${countType}`];
                        bStat.s_play_count = s[`${type}_s_${countType}`];

                        newStatSummary.total += bStat.total;
                        newStatSummary.v_total += bStat.v_play_count;
                        newStatSummary.r_total += bStat.r_play_count;
                        newStatSummary.s_total += bStat.s_play_count;
                        if (bStat.v_play_count > 0 || bStat.r_play_count > 0 || bStat.s_play_count > 0) {
                            newStat.push(bStat);
                        }
                    }
                }
            });
        }
        newStat.sort((a, b) => b.total - a.total);
        setStat(newStat);
        setStatSummary(newStatSummary);
    };
    const getStat = useCallback(() => {
        clearStat();
        if (selectedCategorySubOption != "-") {
            axios({
                method: "POST",
                url: `/api/stat_momo/hq/branches`,
                data: {
                    startDate: statPeriod.startDate,
                    endDate: statPeriod.endDate,
                    periodType: statPeriod.type,
                },
            })
                .then((result) => {
                    if (result.data.code === 200) {
                        if (result.data.branches && result.data.branches.length > 0) {
                            result.data.branches.forEach((s) => {
                                s.total_play_count = s.k_v_play_count + s.k_r_play_count + s.k_s_play_count + s.m_v_play_count + s.m_r_play_count + s.m_s_play_count;
                                s.total_play_count_sum = s.k_v_play_count_sum + s.k_r_play_count_sum + s.k_s_play_count_sum + s.m_v_play_count_sum + s.m_r_play_count_sum + s.m_s_play_count_sum;
                            });
                            result.data.branches.sort((a, b) => b.total_play_count_sum - a.total_play_count_sum);
                        }
                        setStatAll(result.data.branches);
                    } else {
                        alert(result.data && result.data.msg ? result.data.msg : "통계 정보를 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                    }
                })
                .catch((error) => {
                    console.log(error);
                    console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                });
        }
    }, [statPeriod]);
    useEffect(() => {
        if (!subOptionApplied && updateCategorySubOption) {
            updateCategorySubOption(
                [
                    { name: "한글", id: "k" },
                    { name: "수학", id: "m" },
                ],
                "k"
            );
            updateCategorySubOption2(
                [
                    { name: "콘텐츠 순 실행 수", id: "play_count" },
                    { name: "콘텐츠 누적 실행 수", id: "play_count_sum" },
                ],
                "play_count"
            );
            setStatBranchList(branchList);
            setSubOptionApplied(true);
        } else {
            getStat();
        }
        return () => {};
    }, [getStat, subOptionApplied]);
    useEffect(() => {
        applyStatView();
    }, [statAll, selectedCategorySubOption, selectedCategorySubOption2]);
    const chartOption = {
        xAxis: {
            field: "branchName",
            option: {
                axisLabel: {
                    show: true,
                    interval: 0,
                    rotate: 45,
                },
            },
        },
        yAxis: {
            name: "건",
            series: statStyle.seriesContentChart,
        },
        stacks: [{ stack: "base", title: `${selectedCategorySubOption2 === "콘텐츠 순 실행 수" ? "순" : "누적"} 실행 수`, showSum: false, showSumTooltip: true, showPercent: true }],
        showLegend: true,
        legend: {
            x: "right",
            y: "top",
        },
        grid: {
            top: "10%",
            left: "5%",
            right: "5%",
            bottom: "20%",
        },
        tooltipFormatter: (params, chart, test) => {
            var tooltipHtml = [""];
            var tooltipTitlePrefix = `${selectedCategorySubOption2 === "play_count" ? "순" : "누적"} 실행 수`;
            var tooltipTitle = "";
            var total = 0;
            params.map((e) => {
                if (e.seriesName.indexOf("Sum-") < 0) {
                    total += e.value;
                }
            });
            params.map((e) => {
                if (e.seriesName.indexOf("Sum-") < 0) {
                    if (!tooltipTitle) tooltipTitle = e.name + " " + tooltipTitlePrefix;
                    const stackIndex = 0;
                    tooltipHtml[stackIndex] += e.marker + e.seriesName + " : " + (e.value ? e.value.toLocaleString() : "-");
                    tooltipHtml[stackIndex] += total > 0 ? ` (` + Math.round((e.value / total) * 100) + "%)" : "";
                    tooltipHtml[stackIndex] += "<br/>";
                }
            });
            var tooltip = tooltipTitle + '<div class="text-left">';
            tooltipHtml.forEach((t, index) => {
                tooltip += t;
            });

            tooltip += `<b>합계: ${total.toLocaleString()}</b>`;
            tooltip += `</div>`;

            return tooltip;
        },
    };

    const typeTitle = selectedCategorySubOption2 === "play_count" ? "순" : "누적";

    return (
        <div className="stat-branch-content">
            <div className="row mb-2">
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-6">
                    <CardStatContent
                        id="1"
                        title={`전체 콘텐츠 ${typeTitle} 실행 수`}
                        average={stat && !isNaN((statSummary.total / stat.length).toFixed(0)) ? (statSummary.total / stat.length).toFixed(0) : "0"}
                        titleTotal="합계:"
                        total={statSummary.total}
                        titleBgClass="bg-tomonote"
                    />
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-6">
                    <CardStatContent
                        id="1"
                        title={`영상 콘텐츠 ${typeTitle} 실행 수`}
                        average={stat && !isNaN((statSummary.v_total / stat.length).toFixed(0)) ? (statSummary.v_total / stat.length).toFixed(0) : "0"}
                        titleTotal="합계:"
                        total={statSummary.v_total}
                        titleBgClass="bg-tomonote"
                    />
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-6">
                    <CardStatContent
                        id="1"
                        title={`리뷰 콘텐츠 ${typeTitle} 실행 수`}
                        average={stat && !isNaN((statSummary.r_total / stat.length).toFixed(0)) ? (statSummary.r_total / stat.length).toFixed(0) : "0"}
                        titleTotal="합계:"
                        total={statSummary.r_total}
                        titleBgClass="bg-tomonote"
                    />
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-6">
                    <CardStatContent
                        id="1"
                        title={`스페셜 콘텐츠 ${typeTitle} 실행 수`}
                        average={stat && !isNaN((statSummary.s_total / stat.length).toFixed(0)) ? (statSummary.s_total / stat.length).toFixed(0) : "0"}
                        titleTotal="합계:"
                        total={statSummary.s_total}
                        titleBgClass="bg-tomonote"
                    />
                </div>
            </div>
            <div className="row mb-3">
                <div className="col">
                    <div className="card">
                        <div className="card-body" style={{ height: "500px", textAlign: "center" }}>
                            <CommonHorizontalBarChart chartData={stat} chartOption={chartOption} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default BranchContent;
